import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { Navbar, Footer } from "../../components/Layout";
import { toast, Toaster } from "sonner";
import { KeyRound, ArrowRight } from "lucide-react";

export default function TenantLogin() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [pwd, setPwd] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, pwd);
      if (u.role !== "tenant") {
        toast.error("Cet espace est réservé aux locataires");
      } else {
        navigate("/locataire");
      }
    } catch (e) {
      toast.error("Identifiants incorrects");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#F9F9F7]">
      <Navbar />
      <Toaster richColors position="top-right" />
      <section className="max-w-md mx-auto px-6 py-16">
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#FFC107] mb-4">— Espace locataire</div>
        <h1 className="font-display font-black text-4xl tracking-tight mb-3">Connexion locataire</h1>
        <p className="text-slate-600 mb-10 text-sm">Accédez à votre bail, vos quittances et vos documents.</p>

        <form onSubmit={submit} className="bg-white border border-slate-900/15 p-8 space-y-5" data-testid="tenant-login-form">
          <Field label="Email">
            <input required type="email" value={email} onChange={e => setEmail(e.target.value)} className="input" data-testid="tl-email" />
          </Field>
          <Field label="Mot de passe">
            <input required type="password" value={pwd} onChange={e => setPwd(e.target.value)} className="input" data-testid="tl-password" />
          </Field>
          <button type="submit" disabled={busy} data-testid="tl-submit"
            className="btn-brutal btn-brutal-solar w-full px-6 py-3 font-bold uppercase tracking-wider text-sm flex items-center justify-center gap-3 disabled:opacity-50">
            <KeyRound className="w-4 h-4" /> {busy ? "Connexion..." : "Se connecter"} <ArrowRight className="w-4 h-4" />
          </button>
          <p className="text-xs text-slate-500 text-center pt-2">
            Vous n'avez pas reçu vos identifiants ? Contactez-nous à <a href="mailto:contact@immobiliersolaire.fr" className="underline">contact@immobiliersolaire.fr</a>
          </p>
        </form>
      </section>
      <Footer />
    </div>
  );
}

const Field = ({ label, children }) => (
  <label className="block">
    <span className="text-xs font-bold uppercase tracking-widest text-slate-500 mb-2 block">{label}</span>
    {children}
  </label>
);
